// plugins/detect.client.ts
import { defineNuxtPlugin } from '#app'
import { useVmStore }            from '~/stores/vm'  

export default defineNuxtPlugin((nuxtApp) => {
  const vm = useVmStore()

  // grab the UA only once
  const ua = navigator.userAgent

  // detect Safari (but not Chrome/Chromium/Android)
  vm.isSafari = /^((?!chrome|chromium|android).)*safari/i.test(ua)

  // detect common mobile/touch user-agents
  vm.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua)
})
